import React, { forwardRef } from 'react';
import './Button.css';

export const Button = forwardRef(({
  type = 'solid',
  size = 'medium',
  state = 'default',
  icon,
  children,
  onClick,
  disabled = false,
  className = '',
  htmlType = 'button',
  ...props
}, ref) => {
  const baseClass = 'button';
  const typeClass = `button--${type}`;
  const sizeClass = `button--${size}`;
  const stateClass = `button--${state}`;
  const disabledClass = disabled ? 'button--disabled' : '';

  const combinedClassName = [
    baseClass,
    typeClass,
    sizeClass,
    stateClass,
    disabledClass,
    className
  ].filter(Boolean).join(' ');

  return (
    <button
      ref={ref}
      className={combinedClassName}
      onClick={onClick}
      disabled={disabled}
      type={htmlType}
      {...props}
    >
      {icon && (
        <span className="button__icon">
          {icon}
        </span>
      )}
      {children && (
        <span className="button__text">
          {children}
        </span>
      )}
    </button>
  );
});

Button.displayName = 'Button';
